export default "__VITE_ASSET__D6hD5qXS__"